/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  getBoards() {
    return axios.get(`${this.url}/boards`);
  }

  setupFunnel() {
    return axios.post(`${this.url}/boards/setup_funnel`);
  }

  getBoard(publicId) {
    return axios.get(`${this.url}/boards/${publicId}`);
  }

  createBoard(board) {
    return axios.post(`${this.url}/boards`, { board });
  }

  updateBoard(publicId, board) {
    return axios.patch(`${this.url}/boards/${publicId}`, { board });
  }

  deleteBoard(publicId) {
    return axios.delete(`${this.url}/boards/${publicId}`);
  }

  migrateBoard(sourceBoardPublicId, payload) {
    return axios.post(
      `${this.url}/boards/${sourceBoardPublicId}/migrate`,
      payload
    );
  }

  createColumn(column) {
    return axios.post(`${this.url}/columns`, { column });
  }

  updateColumn(publicId, column) {
    return axios.patch(`${this.url}/columns/${publicId}`, { column });
  }

  deleteColumn(publicId) {
    return axios.delete(`${this.url}/columns/${publicId}`);
  }

  reorderColumns(columns) {
    return axios.post(`${this.url}/columns/reorder`, { columns });
  }

  getCards() {
    return axios.get(`${this.url}/cards`);
  }

  getCard(publicId) {
    return axios.get(`${this.url}/cards/${publicId}`);
  }

  createCard(card) {
    return axios.post(`${this.url}/cards`, { card });
  }

  updateCard(publicId, card) {
    return axios.patch(`${this.url}/cards/${publicId}`, { card });
  }

  moveCard(publicId, card) {
    return axios.patch(`${this.url}/cards/${publicId}/move`, { card });
  }

  deleteCard(publicId) {
    return axios.delete(`${this.url}/cards/${publicId}`);
  }

  getActivities(cardPublicId) {
    return axios.get(`${this.url}/cards/${cardPublicId}/activities`);
  }

  createActivity(cardPublicId, body) {
    return axios.post(`${this.url}/cards/${cardPublicId}/activities`, { body });
  }

  deleteActivity(cardPublicId, activityPublicId) {
    return axios.delete(
      `${this.url}/cards/${cardPublicId}/activities/${activityPublicId}`
    );
  }

  getTasks(cardPublicId) {
    return axios.get(`${this.url}/cards/${cardPublicId}/tasks`);
  }

  createTask(cardPublicId, title) {
    return axios.post(`${this.url}/cards/${cardPublicId}/tasks`, { title });
  }

  updateTask(cardPublicId, taskPublicId, data) {
    return axios.patch(
      `${this.url}/cards/${cardPublicId}/tasks/${taskPublicId}`,
      data
    );
  }

  deleteTask(cardPublicId, taskPublicId) {
    return axios.delete(
      `${this.url}/cards/${cardPublicId}/tasks/${taskPublicId}`
    );
  }
}

export default new KanbanAPI();
